import React, { Component } from "react";
import PropTypes from "prop-types";
import { DialogBox, DialogBoxFooterType, NoLink, SelectInput, ZeroToInfiniteGrid } from "~/core";
import { withEditableGrid } from "~/hocs";
import { mapToPicklistValue, prepareSelectableOptions } from "~/admin/utils";
import { adminData, GUID, ID, NAME, PICKLIST_GUID, VALUE } from "~/admin/data";
import { messages } from "./../i18n-messages";
import { createAddLinkLabelText, createAddEditModalTitle } from "~/i18n-messages";

// Styles
import "./component.css";

const PROPS_CROP_NAME = "cropName";
const PROPS_CROP_GUID = "cropGuid";

class CropName extends Component {
    static propTypes = {
        deleteItem: PropTypes.func,
        editData: PropTypes.object,
        formatMessage: PropTypes.func,
        isDeleting: PropTypes.bool,
        isEditing: PropTypes.bool,
        onAdd: PropTypes.func,
        onAddOrEditItem: PropTypes.func,
        onChange: PropTypes.func,
        onDelete: PropTypes.func,
        onEdit: PropTypes.func,
        options: PropTypes.array,
        record: PropTypes.array,
        renderDeleteModal: PropTypes.func,
        toggleModal: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            editOptions: [],
            editingItem: false,
            records: [],
            lastRecord: null,
            lastOptions: null,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { record, options } = nextProps;
        if (record === prevState.lastRecord && options === prevState.lastOptions) {
            return null;
        }
        const records = (record || []).map((recordItem) => {
            const selectedCropName = (options || []).find((cropNameItem) => {
                return cropNameItem.guid === recordItem[PROPS_CROP_GUID];
            });
            return {
                ...recordItem,
                [PROPS_CROP_NAME]:
                    (selectedCropName && selectedCropName[NAME]) || recordItem[PROPS_CROP_NAME],
            };
        });
        return {
            records,
            lastRecord: record,
            lastOptions: options,
        };
    }

    initializeDropdowns = (options) => {
        this.setState({
            editOptions: prepareSelectableOptions(options, {
                guid: GUID,
                label: NAME,
                id: ID,
            }),
        });
    };

    onEdit = (record, index) => {
        this.initializeDropdowns(this.props.options);
        this.setState({ editingItem: true });
        const keysToUpdate = [
            {
                name: [PROPS_CROP_GUID],
                key: PICKLIST_GUID,
            },
            {
                name: [PROPS_CROP_NAME],
                key: VALUE,
            },
        ];
        this.props.onEdit({ record, index, keysToUpdate });
    };

    onDelete = (record, index) => {
        this.props.onDelete({ record, index });
    };

    onAdd = () => {
        this.initializeDropdowns(this.props.options);
        this.setState({ editingItem: false });
        this.props.onAdd();
    };

    renderAddEditModal = () => {
        const { formatMessage, isEditing, editData, onAddOrEditItem, toggleModal } = this.props;
        return (
            <DialogBox
                action="save"
                actionDisabled={!editData[PROPS_CROP_GUID]}
                footerType={DialogBoxFooterType.ACTION_CANCEL}
                forceOverflow
                isOpen={isEditing}
                onAction={() => onAddOrEditItem()}
                onClose={() => toggleModal("isEditing", false)}
                title={createAddEditModalTitle(
                    this.state.editingItem,
                    formatMessage,
                    messages.crop
                )}
                testId="crop-name-add-edit-modal"
            >
                <SelectInput
                    tabIndex={0}
                    autoFocus
                    optionIsHiddenKey={adminData.PROPS_ACTIVE_YN}
                    openOnFocus={false}
                    options={this.state.editOptions}
                    placeholderText={formatMessage(messages.cropName)}
                    value={mapToPicklistValue({
                        options: this.state.editOptions,
                        selectedGuid: editData[PROPS_CROP_GUID],
                    })}
                    onChange={(value) => {
                        this.props.onChange({
                            [PROPS_CROP_GUID]: value ? value.guid : "",
                        });
                    }}
                    testId="crop-name-crop-name-select"
                />
            </DialogBox>
        );
    };

    render() {
        const { formatMessage, renderDeleteModal } = this.props;
        const { records } = this.state;
        return (
            <div className={"form-section-child-stretch mini-grid"}>
                {records && records.length > 0 && (
                    <ZeroToInfiniteGrid
                        records={records}
                        columns={{
                            [PROPS_CROP_NAME]: {
                                title: formatMessage(messages.name),
                            },
                        }}
                        className={"cell-stretch"}
                        onEdit={this.onEdit}
                        onDelete={this.onDelete}
                        showHeader={false}
                    />
                )}
                {this.renderAddEditModal()}
                {renderDeleteModal()}
                <div className="sub-description-container">
                    <NoLink
                        className="add-link"
                        label={createAddLinkLabelText(formatMessage, messages.crop)}
                        onClick={this.onAdd}
                    ></NoLink>
                    <span className="sub-description">
                        {formatMessage(messages.cropSubDescription)}
                    </span>
                </div>
            </div>
        );
    }
}

export default withEditableGrid(CropName);
